module.exports = __webpack_public_path__ + "media/images/application/template/cc-home-bkg-2500px-dark-theme-6fa674604b0d170c6b5e186bfa683d8d.jpg";